

import { ChangeEvent } from 'react';

type Props = {
  search: string;
  totalEmployees: number;
  onSearchChange: (value: string) => void;
};

const NtIdToolbar = ({
  search,
  totalEmployees,
  onSearchChange,
}: Props) => {
  const handleSearchChange = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    onSearchChange(event.target.value);
  };

  return (
    <div
      className="
        flex
        flex-col
        gap-3
        rounded-lg
        border
        border-[#E5E7EB]
        bg-white
        px-4
        py-3
        shadow-sm
        md:flex-row
        md:items-center
        md:justify-between
      "
    >
      <div>
        <h2 className="text-base font-semibold text-[#1F2937]">
          Employee Directory
        </h2>

        <p className="mt-0.5 text-xs text-[#6B7280]">
          Total Employees:{' '}
          <span className="font-semibold">
            {totalEmployees}
          </span>
        </p>
      </div>

      <div className="relative w-full md:w-[340px]">
        <svg
          className="
            absolute
            left-3
            top-1/2
            h-4
            w-4
            -translate-y-1/2
            text-[#9CA3AF]
          "
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
        </svg>

        <input
          type="text"
          value={search}
          onChange={handleSearchChange}
          placeholder="Search Employee..."
          aria-label="Search employees"
          className="
            h-9
            w-full
            rounded-md
            border
            border-[#D1D5DB]
            bg-white
            pl-9
            pr-9
            text-xs
            text-[#374151]
            outline-none
            transition
            placeholder:text-[#9CA3AF]
            focus:border-[#4B2E9E]
            focus:ring-2
            focus:ring-[#E9E2FF]
          "
        />

        {search.length > 0 && (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            aria-label="Clear search"
            className="
              absolute
              right-3
              top-1/2
              -translate-y-1/2
              text-sm
              text-[#9CA3AF]
              hover:text-[#374151]
            "
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default NtIdToolbar;
